import Countdown from '../../../components/Countdown/Countdown';
import type { RaceQuery } from '../../../generated/graphql';
import { Grid } from '@mui/material'
import styles from './RaceHeader.module.css'
import clsx from 'clsx';
import useAppState from '../../../hooks/useAppState';

interface Props {
  race: null | Omit<NonNullable<RaceQuery['race']>, '__typename'>;
}

export default function RaceHeader({ race }: Props) {
  const { controllerState } = useAppState();
  
  // TODO Add loading component
  if (!race) return null;

  return (
    <Grid className={clsx(styles.raceHeader, styles[`raceHeader-${controllerState}-${race.meeting.track.state}`])}>
      <Grid>
        <span className={styles.trackNameAndNumber}>
          {race.meeting.track.name} R{race.number}
        </span>{' '}
        {race.name} - {race.distance}m
      </Grid>
      <Grid sx={{ '&:last-child': { pb: 0 }, 'color': 'black'}}>
        <div className={styles.counterStatus}>
          {race?.startTime && race.status === 'OPEN' ? <Countdown time={race.startTime} /> : race.status !== 'OPEN' ? (
            <>
              { race.status }
            </>
          ) : null}
        </div>
      </Grid>
    </Grid>
  );
}
